import React from 'react';

import { lazyImport } from 'services/lazy-service';

import LazyComponent from 'components/LazyComponent';

const PublicPage = lazyImport(() => import(/* webpackChunkName: "PublicPageChunk"*/ 'pages/public-page'));

const LazyPublicPage = props => (
    <LazyComponent>
        <PublicPage {...props} />
    </LazyComponent>
);

export default React.memo(LazyPublicPage);
